module.exports = __webpack_public_path__ + "static/media/cart-product-4.7cf093f6.png";